import NotificationSubscriptions from '../api/notificationSubscription';

export const firebaseWebConfig = () => window.chatwootConfig?.firebaseWeb;

const storageKey = suffix =>
  `talkvia-firebase-${firebaseWebConfig()?.config.projectId}-${suffix}`;

const loadMessaging = async () => {
  const sdk = await import('firebase/messaging');
  if (!(await sdk.isSupported()))
    throw new Error('Push não disponível neste navegador.');
  const { initializeApp, getApps } = await import('firebase/app');
  const app =
    getApps().find(item => item.name === 'talkvia-push') ||
    initializeApp(firebaseWebConfig().config, 'talkvia-push');
  return { sdk, messaging: sdk.getMessaging(app) };
};

export const registerFirebasePush = async registration => {
  const config = firebaseWebConfig();
  const { sdk, messaging } = await loadMessaging();
  const oldSubscription = await registration.pushManager.getSubscription();
  // Existing Web Push subscriptions may use a different VAPID certificate.
  if (oldSubscription) {
    const key = oldSubscription.options?.applicationServerKey;
    const encoded =
      key &&
      btoa(String.fromCharCode(...new Uint8Array(key)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
    if (encoded !== config.vapidKey.replace(/=+$/, '')) {
      await oldSubscription.unsubscribe();
    }
  }
  const token = await sdk.getToken(messaging, {
    vapidKey: config.vapidKey,
    serviceWorkerRegistration: registration,
  });
  if (!token) throw new Error('Não foi possível registrar as notificações.');
  let deviceId = localStorage.getItem(storageKey('device'));
  if (!deviceId) {
    deviceId = `web:${config.config.projectId}:${crypto.randomUUID()}`;
    localStorage.setItem(storageKey('device'), deviceId);
  }
  await NotificationSubscriptions.create({
    subscription_type: 'fcm',
    subscription_attributes: {
      push_token: token,
      device_id: deviceId,
      platform: 'web',
      project_id: config.config.projectId,
    },
  });
  localStorage.setItem(storageKey('token'), token);
  if (oldSubscription) {
    await NotificationSubscriptions.removeSubscription({
      endpoint: oldSubscription.endpoint,
    });
  }
};

export const unregisterFirebasePush = async () => {
  if (!firebaseWebConfig()) return;
  const token = localStorage.getItem(storageKey('token'));
  if (!token) return;
  const { sdk, messaging } = await loadMessaging();
  await Promise.all([
    sdk.deleteToken(messaging),
    NotificationSubscriptions.removeSubscription({ push_token: token }),
  ]);
  localStorage.removeItem(storageKey('token'));
};
